import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-error-toast',
  imports: [IonicModule],
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss']
})
export class ErrorToastComponent {
  @Input() title: string;
  @Input() html: string;

  reload() {
    window.location.reload();
  }
}